"use client";

import { FC } from "react";
import { Text, Stack } from "@chakra-ui/react";
import { useQuery } from "@apollo/client/react";
import gql from "graphql-tag";
import Button from "../../../components/Button";
import { openCheckout } from "../../../lib/paddleClient";
import { Price } from "../../../types/subscription";

const GET_PRICE = gql`
  query GetPrice {
    price {
      id
      value
    }
  }
`;

type Props = {
  userId: string;
  email: string;
};

const SubscriptionInactiveMessage: FC<Props> = ({ userId, email }) => {
  const { data: priceData, loading } = useQuery<{ price: Price }>(GET_PRICE);
  const priceId = priceData?.price.id;

  return (
    <Stack gap={3}>
      <Text>Hi {email}!</Text>
      <Text>
        Your account is verified but payment is required to gain access.
      </Text>
      <Button
        visual="primary"
        loading={loading || !priceId}
        onClick={() => openCheckout(userId, email, priceId!)}
      >
        Make a payment
      </Button>
    </Stack>
  );
};

export default SubscriptionInactiveMessage;
